<script lang="ts">
  /* The time slot's panel.
   *
   * ═══ WHY IT IS ALMOST EMPTY, AND SHOULD BE ═══
   *
   * The cursor's CONTROL is the tideline, which is permanent chrome on every
   * viewport. This panel exists because the dock's pinned time slot has to lead
   * somewhere when tapped, and because the coarse jumps want a home.
   *
   * What it deliberately does NOT do is restate the time. Windy renders it in
   * the slider handle AND on the timeline it points at, they disagree, and its
   * users say they cannot tell which to trust. The dock slot shows the reading;
   * the sheet's peek line shows it; a third copy here would be the fault that
   * warning describes, committed by the file quoting it.
   */
  import Button from '@gennetay/chart-ui/primitives/Button';
  import ButtonRow from '@gennetay/chart-ui/primitives/ButtonRow';
  import SectionHeader from '@gennetay/chart-ui/primitives/SectionHeader';
  import { viewTime } from '@gennetay/chart-core/lib/viewtime.svelte';
  import { panels } from '@gennetay/chart-ui/shell';
  import { tideline } from '../tideline.svelte';

  const H = 3_600_000;
</script>

<p class="lede">
  The tideline along the bottom is the clock for the whole chart — tides, currents and weather all
  follow it. Where narrows are in view it also marks the slack windows; scrub to one and that
  becomes your departure time.
</p>

{#if tideline.collapsed}
  <ButtonRow>
    <Button
      onclick={() => {
        tideline.collapsed = false;
        panels.close('time');
      }}>Open the tideline</Button
    >
  </ButtonRow>
{/if}

<SectionHeader title="Jump" />
<p class="hint">Bigger steps for the same clock.</p>
<ButtonRow>
  <Button ariaLabel="Back 6 hours" onclick={() => viewTime.scrub(viewTime.now - 6 * H)}>− 6h</Button>
  <Button ariaLabel="Back 1 hour" onclick={() => viewTime.scrub(viewTime.now - H)}>− 1h</Button>
  <Button ariaLabel="Forward 1 hour" onclick={() => viewTime.scrub(viewTime.now + H)}>+ 1h</Button>
  <Button ariaLabel="Forward 6 hours" onclick={() => viewTime.scrub(viewTime.now + 6 * H)}>+ 6h</Button>
</ButtonRow>
<div class="gap"></div>
{#if viewTime.isLive}
  <!-- #52: a live cursor is STATE, not an action — plain status text, never a
       disabled button that looks pressable but isn't. -->
  <p class="status">Showing now</p>
{:else}
  <Button block onclick={() => viewTime.reset()}>Back to now</Button>
{/if}

<style>
  .lede {
    margin: 0 0 var(--sp-5);
    font: var(--fs-read) / var(--lh-read) var(--sans);
    color: var(--sub);
  }
  .hint {
    margin: calc(-1 * var(--sp-2)) 0 var(--sp-4);
    font: var(--fs-read) / var(--lh-read) var(--sans);
    color: var(--sub);
  }
  .gap {
    height: var(--sp-4);
  }
  .status {
    margin: 0;
    font: var(--fs-read) / var(--lh-read) var(--sans);
    color: var(--sub);
    text-align: center;
  }
</style>
